import { render, staticRenderFns } from "./StatBadge.vue?vue&type=template&id=34a08c46&scoped=true"
import script from "./StatBadge.vue?vue&type=script&lang=js"
export * from "./StatBadge.vue?vue&type=script&lang=js"
import style0 from "./StatBadge.vue?vue&type=style&index=0&id=34a08c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a08c46",
  null
  
)

export default component.exports